<template>
  <div class="donate col offset-lg-1 col-lg-10">
    <div class="card">
      <div class="card-header">
        <h2 class="card-title">Donate</h2>
      </div>
      <div class="card-body" v-show="web3jsInited">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="sha256-prefix">ETH</span>
          </div>
          <input v-model="amount" type="number" min="0.01" step="0.01" class="form-control" placeholder="Amount to donate" aria-label="Amount to donate" aria-describedby="basic-addon2">
          <div class="input-group-append">
            <button class="input-group-btn btn-secondary send-button" :disabled="!amountIsValid" @click="donateClick">Send</button>
          </div>
        </div>
        <div v-if="null != donateResult">
          <h1>Thank you!</h1>
          <p class="text-success">Your donation was successfully sent</p>
          <p class="text-success">Transaction ID: {{ donateResult }}</p>
        </div>
        <div v-if="null == web3account">
          <p class="text-warning">Waiting for available Web3 account...</p>
        </div>
        <div v-if="null != donateError || null != error">
          <p class="text-warning">{{ donateError || error }}</p>
        </div>
      </div>
      <div class="card-body" v-show="!web3jsInited">
        <p class="card-body-text">Please enabled MetaMask to donate ETH</p>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue               from 'vue'
  import { mapActions
         , mapGetters
         , mapState      } from 'vuex'

  export default {
    name: 'Donate'
  , props: {}
  , data: () => ({
      amount: 0.1
    , error: null
    })
  , componentes: {}
  , computed: {
      ...mapState(['web3jsInited', 'web3network', 'web3account', 'web3Error', 'web3Transaction'])
    , ...mapState(['donateResult', 'donateError'])
    , amountIsValid() {
        const amount = parseFloat(this.amount, 10)
        return ( !isNaN(amount) && amount > 0.00001 )
      }
    }
  , methods: {
      ...mapActions([ 'initWeb3JS', 'getAccount', 'donateWeb3', 'getGasPrice' ])
    , donateClick() {
        return this.getAccount()
          .then(result => {
            if (!result) {
              this.error = "No active Web3 account selected"
            } else {
              this.donateWeb3(parseFloat(this.amount, 10))
            }
          })
      }
    }
  , mounted () {
      return this.initWeb3JS().then(
          result =>
            result
            ? this.getAccount().then(() => this.getGasPrice())
            : (this.error = "Web3 is unavailable", this.error)
        )
    }
  }
</script>

<style scoped>
  .send-button {
    min-width: 10em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Donate.vue